import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { DynamicTableStateless } from '@atlaskit/dynamic-table';
import { useHistory } from '@atlassian/mpac-ui';
import { DynamicTableUtils } from '@atlassian/mpac-utils';
import isEqual from 'lodash/isEqual';
import React, { useState } from 'react';
import { PAGINATION_LIMIT } from "../../../constants/Preferences";
import NoResultView from "../../../utils/NoResultView";
import ErrorMessage from "../Common/ErrorMessage";
import { REPORTS_NO_RESULT_SUBTITLE, REPORTS_NO_RESULT_TITLE } from "../PartnerReports.constants";
import { transactionDetailsConfig } from "../ReportDetails/ReportDetailsConfig/TransactionDetailsConfig";
import ReportDetailsModal from "../ReportDetails/ReportDetailsModal";
import { getNewReportPathname, getNewSearch } from "../ReportsFilters/ReportFilters.utils";
import { useTransactionsReports } from "./hooks";
import { getTransactionsReportsBody, TransactionsReportsHeader } from "./TransactionsReportsTableData";

const TransactionsReports = props => {
  const history = useHistory();
  const {
    transactionsAPIResponse,
    pending,
    error
  } = useTransactionsReports(props.mpacBaseUrl, props.partnerId, props.queryParams);
  const [selectedTransaction, setSelectedTransaction] = useState();
  const totalCount = transactionsAPIResponse === null || transactionsAPIResponse === void 0 ? void 0 : transactionsAPIResponse.totalCount;
  const rowsPerPage = DynamicTableUtils.getRowsPerPage(totalCount, PAGINATION_LIMIT);
  const offset = props.queryParams.offset || 0; // eg: If offset is 10, page number would be 2 (10/10 + 1)

  const pageNum = Number.parseInt(offset.toString(), 10) / rowsPerPage + 1;

  const updateQueryParams = (queryParam, value) => {
    history.push({
      pathname: getNewReportPathname(props.partnerId, props.reportName, false, ''),
      search: getNewSearch(props.queryParams, queryParam, value)
    });
  };

  const getReportsLink = (queryParam, value, columnName) => {
    const reportName = columnName === 'licenseId' ? 'licenses' : props.reportName;
    const pathname = getNewReportPathname(props.partnerId, reportName, false, '');
    const search = getNewSearch(_objectSpread(_objectSpread({}, props.queryParams), {}, {
      offset: '0'
    }), queryParam, value);
    return pathname + search;
  };

  const onViewTransactionClick = transactionDetails => setSelectedTransaction(transactionDetails);

  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(ErrorMessage, {
    error: error.error,
    status: error.status
  }), !error && /*#__PURE__*/React.createElement(DynamicTableStateless, {
    head: TransactionsReportsHeader,
    rows: getTransactionsReportsBody((transactionsAPIResponse === null || transactionsAPIResponse === void 0 ? void 0 : transactionsAPIResponse.transactions) || [], getReportsLink, onViewTransactionClick),
    isLoading: pending,
    rowsPerPage: rowsPerPage,
    page: pageNum,
    onSetPage: page => updateQueryParams('offset', ((page - 1) * PAGINATION_LIMIT).toString()),
    totalRows: totalCount,
    emptyView: /*#__PURE__*/React.createElement(NoResultView, {
      title: REPORTS_NO_RESULT_TITLE,
      subtitle: REPORTS_NO_RESULT_SUBTITLE
    })
  }), selectedTransaction && /*#__PURE__*/React.createElement(ReportDetailsModal, {
    header: "Transaction details",
    reportDetails: selectedTransaction,
    onClose: () => setSelectedTransaction(),
    reportDetailsConfig: transactionDetailsConfig
  }));
};

export default /*#__PURE__*/React.memo(TransactionsReports, isEqual);